import React from "react";
import { Helmet } from "react-helmet-async";
import Lantern from "../Images/Lantern.jpg";
import Youtube02 from "../Images/2021.jpg";
import Youtube03 from "../Images/2020beingalive.jpg";
import Youtube04 from "../Images/2020Kronos.jpg";
import Youtube05 from "../Images/2020PLcataluna.jpg";
import BandCamp from "../Images/2019.jpg";
import Zonawatusa from "../Images/VHS terminal.jpg";
import Listen from "../Images/2023.jpg";
import Portada from "../Images/2024.jpg";
import Comingsoon from "../Images/image.png";
import "../Styles/Music.css";
import { Container } from "react-bootstrap";

function Music() {
  return (
    <>
      <Helmet>
        <title>Music | Kazumi Sakoda</title>
        <meta
          name="description"
          content="Music, albums, releases and sound works by Kazumi Sakoda."
        />
      </Helmet>
      <Container>
        <div className="card mb-3" id="musicCards" style={{ maxWidth: "100%" }}>
          <div className="row g-0">
            <div className="col-md-3">
              <a
                href="https://zonawatusa.bandcamp.com/album/listen-to-the-land-until-it-becomes-your-body
                "
                target="blank"
              >
                <img
                  src={Comingsoon}
                  id="Listen"
                  className="img-fluid rounded-sharp"
                  height="200"
                  alt="lanternimg"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                {/* <h5 className="card-title">Sampling Barcelona 2024</h5> */}
                <p className="card-text">
                  <br />
                  <br />
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <a
                href="https://kazumisakoda.bandcamp.com/album/sampling-barcelona-2023"
                target="blank"
              >
                <img
                  src={Portada}
                  id="Listen"
                  className="img-fluid rounded-sharp"
                  height="200"
                  alt="lanternimg"
                />
              </a>
            </div>
            <div className="col-md-3" id="A">
              <div className="card-body" id="sb2023">
                <h5 className="card-title">2024 “Sampling Barcelona 2023”</h5>
                <p className="card-text">
                  Released by Zona Watusa Label.
                  <br />
                  Mastered by Nick Klein
                  <br />
                  Cover design by Studio Denk
                  <br />
                  Cover photo by Elo Vázquez
                  <br />
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <a
                href="https://kazumisakoda.bandcamp.com/album/listen-to-the-land-until-it-becomes-your-body-sampling-barcelona-2022"
                target="blank"
              >
                <img
                  src={Listen}
                  id="Listen"
                  className="img-fluid rounded-sharp"
                  height="200"
                  alt="lanternimg"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">
                  2023 “Listen To The Land Until It Becomes Your Body”
                </h5>
                <p className="card-text">
                  Sampling Barcelona 2022. Released by Zona Watusa Label. Cover
                  design: Urbild Editions.
                  <br />
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <a
                href="https://kazumisakoda.bandcamp.com/album/vhs-terminal"
                target="blank"
              >
                <img
                  src={Zonawatusa}
                  id="zw"
                  className="img-fluid rounded-sharp"
                  alt="youtube2img"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">2023 "VHS Terminal"</h5>
                <p className="card-text">
                  This is a mini album made by extracting sounds from old VHS
                  found on the street in Barcelona.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-0">
            <div className="col-md-3">
              <a
                href="https://kazumisakoda.bandcamp.com/album/lantern"
                target="blank"
              >
                <img
                  src={Lantern}
                  id="youTubeImg1"
                  className="img-fluid rounded-sharp"
                  height="200"
                  alt="lanternimg"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">2022 "Lantern"</h5>
                <p className="card-text">
                  Sampling Barcelona 2021.
                  <br />
                  Inspired by Asako Yuzuki's novel "Lantern", I composed it for
                  International Women's Day.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <a href="https://youtu.be/eVWkArbC7_o" target="blank">
                <img
                  src={Youtube02}
                  id="youTubeImg2"
                  className="img-fluid rounded-sharp"
                  alt="youtube2img"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">
                  2021 "el bosque corrompido"
                  <br />
                  {/* video by Daniel Clegg */}
                </h5>
                <p className="card-text">
                  What was originally a thing is transformed by a person and
                  becomes a thing again over time or by the sheer force of
                  nature.
                </p>
              </div>
            </div>
          </div>

          <div className="row g-0">
            <div className="col-md-3">
              <a
                href="https://kazumisakoda.bandcamp.com/album/being-alive"
                target="blank"
              >
                <img
                  src={Youtube03}
                  id="youTubeImg3"
                  className="img-fluid rounded-sharp"
                  alt="youtube3img"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">2020 "being alive" with Noman </h5>
                <p className="card-text">
                  Created with Noman between Barcelona and Tokyo during the
                  pandemic. A collaboration shaped by distance and the changing
                  sounds of two cities.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <a href="https://youtu.be/4Y_GCwwb1r0" target="blank">
                <img
                  src={Youtube04}
                  id="youTubeImg4"
                  className="img-fluid rounded-sharp"
                  alt="youtube4img"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">2020 "Barceloneta" with Noman</h5>
                <p className="card-text">
                  Soundtrack “Els Artistes de l'Futur 2020”
                </p>
              </div>
            </div>
          </div>

          <div className="row g-0">
            <div className="col-md-3">
              <a
                href="https://soundcloud.com/kazumisakoda/plcataluna-badalona?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
                target="blank"
              >
                <img
                  src={Youtube05}
                  id="youTubeImg5"
                  className="img-fluid rounded-sharp"
                  alt="youtube5img"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">
                  2020 "Pl.Catalunya - Badalona" at Sangen Chakai streaming
                  channel
                </h5>
                <p className="card-text">
                  Summer. The trains on weekends are full for people who go to
                  the sea and those who return from the sea.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <a href="https://kazumisakoda.bandcamp.com/" target="blank">
                <img
                  src={BandCamp}
                  id="bandcamp"
                  className="img-fluid rounded-sharp"
                  alt="bandcampimg"
                />
              </a>
            </div>
            <div className="col-md-3">
              <div className="card-body">
                <h5 className="card-title">2019 "Sampling Barcelona" </h5>
                <p className="card-text" id="bcCardTx">
                  1. Plaça Universitat
                  <br />
                  2. Carrer Comtal
                  <br />
                  3. Carrer d'En Robador
                  <br />
                  4. Plaça dels Àngels
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="footerInner">
            <p className="footerLink">
              <a href="https://www.instagram.com/kazumi_sakoda/" target="blank">
                INSTAGRAM
              </a>
              <span style={{ fontSize: "8px" }}>•</span>
              <a
                href="https://www.youtube.com/channel/UClGgOLYCBl8Ccz2_nuyjFCw"
                id="videoClip"
                target="blank"
              >
                YOUTUBE
              </a>
              <span style={{ fontSize: "8px" }}>•</span>
              <a
                href="https://kazumisakoda.bandcamp.com/"
                id="videoClip"
                target="blank"
              >
                BANDCAMP
              </a>
            </p>
          </div>
        </div>

        <div className="BioFooter">
          <br />

          <p>© KAZUMI SAKODA 2025</p>
        </div>
      </Container>
    </>
  );
}

export default Music;
